import R from 'app/assets/R'
import HeaderPage from 'app/components/header/components/HeaderPage'
import * as S from 'app/components/tables/BaseTableManagement/styles'
import { UpdateCampaignProvider } from './context'
import { RootLayout } from './RootLayout'
import { useVerifyPermissionAndRedirect } from 'app/common/use-verify-permission-redirect'
import { useEffect } from 'react'
import {
  FunctionPermissionEnum,
  ModulePermissionEnum,
} from 'app/common/permission-module'

const UpdateCampaignLayout = () => {
  const { user, isHavePermissionFunctionAndGoBack } =
    useVerifyPermissionAndRedirect()

  useEffect(() => {
    isHavePermissionFunctionAndGoBack(
      ModulePermissionEnum.MARKETING,
      FunctionPermissionEnum.UPDATE_DISCOUNT_CAMPAIGN,
      R.strings.update_campaign,
    )
  }, [user])

  return (
    <UpdateCampaignProvider>
      <S.BaseManagementWrapper>
        <HeaderPage titleI18nKey={R.strings.update_campaign} />
        <RootLayout />
      </S.BaseManagementWrapper>
    </UpdateCampaignProvider>
  )
}

export default UpdateCampaignLayout
